import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ScreenService} from '@app/core';

@Component({
  selector: 'app-split-btn',
  standalone: false,

  templateUrl: './split-btn.component.html',
  styleUrl: './split-btn.component.less'
})
export class SplitBtnComponent {
  @Input() primaryIcon: string = '';
  @Input() secondaryIcon: string = '';
  @Input() text: string = '';
  @Input() buttonType: 'primary' | 'default' = 'primary';
  @Input() dropdownItems: Array<{label: string, action: string}> = [];

  @Output() primaryActionEvent = new EventEmitter<void>();
  @Output() secondaryActionEvent = new EventEmitter<void>();
  @Output() dropdownActionEvent = new EventEmitter<string>();

  constructor(
    public screenService: ScreenService
  ) {
  }

  emitPrimaryAction() {
    this.primaryActionEvent.emit();
  }

  emitSecondaryAction() {
    this.secondaryActionEvent.emit();
  }

  emitDropdownAction(action: string) {
    this.dropdownActionEvent.emit(action);
  }
}
